import { useEffect, useState } from 'react';
import axios from 'axios';
import buildInfo from '@/buildInfo.json';
import { formatStamp } from '@/utils/datetime';
import { useAuth, isAdmin } from '@/auth/AuthContext';

const TONE = {
  production: 'bg-rose-600 text-white',
  preview: 'bg-amber-500 text-white',
  unknown: 'bg-zinc-400 text-white',
};

// Small, unobtrusive build/version tag so we can tell at a glance whether a
// given environment (preview vs production) is running the latest code.
// Timestamp is shown in the user's timezone with its label (e.g. JST), not UTC.
// A9: 管理者だけに 本番 / プレビュー のバッジも出す（公開前の事故防止）。
export default function BuildTag() {
  const { user } = useAuth();
  const admin = isAdmin(user);
  const [env, setEnv] = useState(null);
  const commit = (buildInfo && buildInfo.commit) || 'dev';
  const when = formatStamp(buildInfo && buildInfo.buildTime);

  useEffect(() => {
    if (!admin) { setEnv(null); return; }
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/system/environment`)
      .then((r) => setEnv(r.data)).catch(() => setEnv(null));
  }, [admin]);

  return (
    <div
      data-testid="build-tag"
      className="no-print select-none text-center text-[11px] leading-none text-zinc-400 py-5"
      title={`Build ${commit}${when ? ` · ${when}` : ''}`}
    >
      {env && (
        <span
          data-testid="env-badge"
          className={`mr-2 inline-block rounded-full px-2 py-0.5 text-[10px] font-bold align-middle ${TONE[env.environment] || TONE.unknown}`}
          title={env.host || ''}
        >
          {env.label}
        </span>
      )}
      build <span className="font-mono text-zinc-500">{commit}</span>
      {when ? <span className="text-zinc-300"> · {when}</span> : null}
    </div>
  );
}
